import skirt from '../../assets/images/skirt.png';
import lip from '../../assets/images/lip.png';
import ketab from '../../assets/images/ketab.png';
import home from '../../assets/images/home.png';
import yummy from '../../assets/images/yummy.png';
import sparkle from '../../assets/images/sparkle.png';
import game from '../../assets/images/game.png';
import nini from '../../assets/images/nini.png';
import olympic from '../../assets/images/olympic.png';
import ship from '../../assets/images/ship.png';
import pets from '../../assets/images/pets.png';

export const categoryData = [
  {
    imgSrc: ship,
    title: 'مسافرت',
    color: '#ceaea2',
    theme: 'light',
    id: 1,
  },
  {
    imgSrc: lip,
    title: 'زیبایی',
    color: '#ff80ab',
    theme: 'light',
    id: 2,
  },
  {
    imgSrc: pets,
    title: 'حیوانات',
    color: '#aebac5',
    theme: 'light',
    id: 3,
  },
  {
    imgSrc: game,
    title: 'بازی',
    color: '#ececec',
    theme: 'dark',
    id: 4,
  },
  {
    imgSrc: skirt,
    title: 'مد و لباس',
    color: '#ff979d',
    theme: 'light',
    id: 5,
  },
  {
    imgSrc: ketab,
    title: 'کتاب',
    color: '#d1b9fc',
    theme: 'light',
    id: 6,
  },
  {
    imgSrc: home,
    title: 'ساختن',
    color: '#88bde8',
    theme: 'light',
    id: 7,
  },
  {
    imgSrc: yummy,
    title: 'خوشمزه',
    color: '#ffa588',
    theme: 'light',
    id: 8,
  },
  {
    imgSrc: sparkle,
    title: 'کاردستی',
    color: '#b4f0e1',
    theme: 'dark',
    id: 9,
  },
  {
    imgSrc: nini,
    title: 'نوزاد',
    color: '#ffe3b9',
    theme: 'dark',
    id: 10,
  },
  {
    imgSrc: olympic,
    title: 'ورزشی',
    color: '#e0edff',
    theme: 'dark',
    id: 11,
  },
];
